import { useState } from 'react'

import type { DomEvidence } from '@/lib/checkoutEvidence'
import { CheckoutConfirmationDialog } from './CheckoutConfirmationDialog'
import type { QuoteCardData } from './quoteCardTypes'
import { useQuoteCart } from './QuoteCartContext'
import { QuoteCartSidebar } from './QuoteCartSidebar'

interface QuoteCartCheckoutProps {
  /** Every quote on the page, not the filtered list — the cart keeps what filters hide. */
  quotes: QuoteCardData[]
  /** Applies the selection. Rejecting leaves the cart untouched so it can be retried. */
  onSubmit: (indicationIds: string[], evidence: DomEvidence) => Promise<void>
  /** Shown at the top of the cart, e.g. why it already holds a quote. */
  notice?: string | null
}

/** The cart sidebar and what follows a successful checkout. */
export function QuoteCartCheckout({ quotes, onSubmit, notice }: QuoteCartCheckoutProps) {
  const { clear, close } = useQuoteCart()
  const [isConfirming, setIsConfirming] = useState(false)

  async function checkOut(indicationIds: string[], evidence: DomEvidence) {
    await onSubmit(indicationIds, evidence)
    clear()
    close()
    setIsConfirming(true)
  }

  return (
    <>
      <QuoteCartSidebar quotes={quotes} onCheckout={checkOut} notice={notice} />
      <CheckoutConfirmationDialog open={isConfirming} onOpenChange={setIsConfirming} />
    </>
  )
}
